import { actionGenerator, IReduxAction } from '../../utils/actions';

export const LOAD_PUBLISH_TERMS_START = 'PUBLISH_TERMS :: LOAD_START';

interface IPayload {
  isReloading: boolean;
}

export type TLoadPublishTermsStartAction = IReduxAction<typeof LOAD_PUBLISH_TERMS_START, IPayload>;

export const loadPublishTermsStart = actionGenerator<typeof LOAD_PUBLISH_TERMS_START, IPayload>(
  LOAD_PUBLISH_TERMS_START,
);
